/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlockTimeCheckbox/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BlockTimeCheckbox({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/BlockTimeCheckbox"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let scheduleNoteTypeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'type',
})
let constantData = 'note'
let aggregateData = fromAggregate.equals(scheduleNoteTypeValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}